"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const tabs_module_scss_1 = __importDefault(require("./tabs.module.scss"));
const Tabs = ({ currentTab = 0, onChange, children }) => {
    const tabs = react_1.Children.toArray(children);
    return ((0, jsx_runtime_1.jsx)("div", { className: tabs_module_scss_1.default.container, children: tabs.map(tab => {
            if (!(0, react_1.isValidElement)(tab)) {
                return tab;
            }
            const { id } = tab.props;
            return (0, react_1.cloneElement)(tab, {
                id,
                className: (0, classnames_1.default)(tabs_module_scss_1.default.tab, currentTab === id && tabs_module_scss_1.default.active),
                color: currentTab === id ? 'grey-gray' : 'white',
                onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(tab.props.id),
            });
        }) }));
};
exports.default = Tabs;
